import { useNavigate } from "react-router-dom";
import { ArrowLeft, ExternalLink, ChevronRight } from "lucide-react";
import PageHeader from '@/components/common/PageHeader';
import { useNavMode } from "@/contexts";
import { adminTabConfig, AdminTabKey } from "@/components/layout/navConfig";
import { GenieIcon } from "@/components/ui/genie-icons/GenieIcon";

const BRAND = "#4E9CFF";

const AdminLanding = () => {
  const { setMode } = useNavMode();
  const navigate = useNavigate();

  const handleItemClick = (itemPath: string, tabKey: AdminTabKey) => {
    navigate(`${itemPath}?tab=${tabKey}`);
  };

  return (
    <div className="min-h-screen bg-genie-primary-light">
      <div className="container mx-auto px-4 py-8 max-w-[1920px]">
        <div className="w-full">
          <PageHeader title="Admin Operations" genieIcon="settings" />
          <div className="mb-6">
            <button
              className="inline-flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-lg bg-genie-primary/10 text-genie-primary hover:bg-genie-primary/20 transition-colors"
              onClick={() => {
                setMode("business");
                navigate("/dashboard");
              }}
            >
              <ArrowLeft className="w-3.5 h-3.5" />
              Back to business view
            </button>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {Object.values(adminTabConfig).map((tab) => (
              <div
                key={tab.key}
                className="p-[2px] rounded-xl bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8]"
              >
                <div className="rounded-[10px] bg-white h-full overflow-hidden flex flex-col">
                  <div
                    className="px-5 py-4 border-b flex items-center gap-3"
                    style={{ background: `${BRAND}05`, borderColor: `${BRAND}15` }}
                  >
                    <div
                      className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
                      style={{ background: `${BRAND}15` }}
                    >
                      <GenieIcon name={tab.genieIcon} size={20} />
                    </div>
                    <div className="min-w-0">
                      <div className="text-base font-bold text-gray-900 leading-tight">{tab.label}</div>
                      <div className="text-xs text-gray-500 mt-0.5">{tab.description}</div>
                    </div>
                  </div>
                  <div className="px-5 py-3 flex flex-col gap-0.5 flex-1">
                    {tab.items.map((item) =>
                      item.externalUrl ? (
                        <a
                          key={item.path}
                          href={item.externalUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="group flex items-center justify-between gap-2 px-3 py-2 rounded-lg text-sm text-gray-700 hover:bg-[#4E9CFF08] hover:text-genie-primary transition-colors"
                        >
                          <span>{item.title}</span>
                          <ExternalLink className="w-3.5 h-3.5 text-gray-400 group-hover:text-genie-primary shrink-0 transition-colors" />
                        </a>
                      ) : (
                        <button
                          key={item.path}
                          onClick={() => handleItemClick(item.path, tab.key)}
                          className="group flex items-center justify-between gap-2 px-3 py-2 rounded-lg text-sm text-gray-700 hover:bg-[#4E9CFF08] hover:text-genie-primary transition-colors text-left w-full"
                        >
                          <span>{item.title}</span>
                          <ChevronRight className="w-3.5 h-3.5 text-gray-300 group-hover:text-genie-primary shrink-0 transition-colors" />
                        </button>
                      )
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLanding;


